import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import { utils, writeFile } from 'xlsx';
import BookingServices from '../services/BookingServices';
import BookingUpdate from './Update Model/bookingUpdate';
import DeleteButton from './Button/DeleteButton';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewOrder from './View Model/ViewOrder';
import { FaArrowLeft } from "react-icons/fa";

Modal.setAppElement('#root');

function Order() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('userId');

  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [run, setRun] = useState(0);

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const navigate = useNavigate();
  const itemsPerPage = 10;

  // Fetch bookings
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = userId
          ? await BookingServices.getUserBooking(userId)
          : await BookingServices.getBooking();
        setData(response?.data || []);
      } catch (err) {
        console.error('Error fetching bookings:', err);
      }
    };
    fetchData();
  }, [userId, run]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const handleEditDetails = (order) => {
    setSelectedEdit(order);
    setIsEditModalOpen(true);
  };

  const handleDelete = (order) => {
    setSelectedEdit(order);
    setIsDeleteModalOpen(true);
  };

  const closeEditModal = () => setIsEditModalOpen(false);
  const closeDeleteModal = () => setIsDeleteModalOpen(false);

  const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB');
  };

  // Search filter (very basic – only on user name & mobile for now)
  const filteredBookings = data.filter((order) => {
    const searchLower = searchQuery.toLowerCase().trim();

    if (!searchLower) return true;

    const firstName = order?.user?.firstName?.toLowerCase() || '';
    const lastName = order?.user?.lastName?.toLowerCase() || '';
    const mobile = order?.user?.mobileNo?.toString() || '';

    return (
      firstName.includes(searchLower) ||
      lastName.includes(searchLower) ||
      mobile.includes(searchLower)
    );
  });

  // Pagination logic
  const indexOfLastBooking = currentPage * itemsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - itemsPerPage;
  const currentBookings = filteredBookings.slice(indexOfFirstBooking, indexOfLastBooking);

  const pageCount = Math.ceil(filteredBookings.length / itemsPerPage);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  // Excel download
  const downloadOrder = () => {
    const formattedData = filteredBookings.map((order, index) => ({
      '#': index + 1,
      'Order ID': order?.bookingId || 'N/A',
      'Customer Name': `${order?.user?.firstName || ''} ${order?.user?.lastName || ''}`.trim() || 'N/A',
      'Mobile': order?.user?.mobileNo || 'N/A',
      'Service Count': order?.services?.length || 0,
      'Booking Date': formatDateTime(order?.createdAt),
      'Vendor Name': order?.vendor?.name || 'Not assigned',
      'Vendor Mobile': order?.vendor?.mobileNo || 'N/A',
    }));

    const worksheet = utils.json_to_sheet(formattedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Orders');
    writeFile(workbook, 'Orders.xlsx');
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">
            Order List <span className="badge bg-orange">{filteredBookings.length}</span>
          </h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active">Order</li>
            </ol>
          </nav>
        </div>

        <div className="d-flex my-xl-auto right-content align-items-center">
          <button
            onClick={handleBack}
            className="btn btn-sm btn-outline-secondary d-flex align-items-center me-3"
          >
            <FaArrowLeft className="me-1" /> Back
          </button>

          {/* <button className="excel-btn" onClick={downloadOrder}>
            <img src="img/excel.svg" alt="Download" /> Download
          </button> */}
        </div>
      </div>

      <div className="container-box px-0" style={{ overflowX: "auto", marginBottom: "60px" }}>
        {/* Search */}
        <div className="Tablesearch_design">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <input
                  type="search"
                  placeholder="Search by name or mobile..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1); // reset to page 1 on new search
                  }}
                  className="form-control"
                />
                <button className="search-btn">Search</button>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="container-box-inner table-reponsive-tabe">
          <table className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Order ID</th>
                <th>USER NAME</th>
                <th>USER MOBILE NO</th>
                <th>SERVICE TYPE</th>
                <th>BOOKING DATE</th>
                <th>VENDOR NAME</th>
                <th>VENDOR MOBILE NO</th>
              </tr>
            </thead>
            <tbody>
              {currentBookings.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    No orders found
                  </td>
                </tr>
              ) : (
                currentBookings.map((order, index) => (
                  <tr key={order._id || index}>
                    <td>{indexOfFirstBooking + index + 1}</td>
                    <td>{order?.bookingId || '—'}</td>
                    <td>
                      {order?.user?.firstName || 'N/A'}{' '}
                      {order?.user?.lastName || ''}
                    </td>
                    <td>{order?.user?.mobileNo || 'N/A'}</td>

                    <td style={{ minWidth: '220px' }}>
                      {order?.services?.length > 0 ? (
                        <ul
                          style={{
                            margin: 0,
                            paddingLeft: '20px',
                            listStyleType: 'disc',
                            fontSize: '0.95em',
                          }}
                        >
                          {order.services.map((item, i) => (
                            <li key={i} style={{ marginBottom: '4px' }}>
                              {item.service?.title || 'Service'} 
                              {item.quantity > 1 && ` ×${item.quantity}`}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span style={{ color: '#888', fontStyle: 'italic' }}>
                          No services
                        </span>
                      )}
                    </td>

                    <td>{formatDateTime(order?.createdAt) || '—'}</td>
                    <td>{order?.vendor?.name || 'Not assigned'}</td>
                    <td>{order?.vendor?.mobileNo || 'N/A'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination - only shows when needed */}
          {pageCount > 1 && (
            <div className="d-flex justify-content-end mt-4">
              <ReactPaginate
                previousLabel="Previous"
                nextLabel="Next"
                pageCount={pageCount}
                onPageChange={handlePageClick}
                forcePage={currentPage - 1}
                containerClassName="pagination"
                activeClassName="active"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                nextClassName="page-item"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                renderOnZeroPageCount={null}
              />
            </div>
          )}
        </div>
      </div>

      {/* View Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Order Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewOrder order={selectedOrder} closeModal={closeModal} />
      </Modal>

      {/* Edit Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="Edit Booking"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <BookingUpdate
          order={selectedEdit}
          closeModal={closeEditModal}
          onSuccess={() => {
            setRun((prev) => prev + 1);
            closeEditModal();
          }}
        />
      </Modal>

      {/* Delete Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton
          data={selectedEdit}
          page="Order"
          closeModal={closeDeleteModal}
          onSuccess={() => {
            setRun((prev) => prev + 1);
            closeDeleteModal();
          }}
        />
      </Modal>
    </div>
  );
}

export default Order;